// src/services/auth_service.js

import Cookies from 'js-cookie'; // Changed from react-cookie to js-cookie for consistency
import { jwtDecode } from "jwt-decode";

const API_URL = `${process.env.REACT_APP_HOST_URL}`; 

const authService = {
  login: async (phoneNumber) => {
    const response = await fetch(`${API_URL}/authenticate/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ phoneNumber }),
    });

    if (!response.ok) {
      throw new Error('Login failed');
    }

    const data = await response.json();
    // We don't set tokens here since this is just sending OTP
    // Tokens will be set after OTP verification
    return data;
  },

  verifyOtp: async (phoneNumber,otp) => {
    const response = await fetch(`${API_URL}/authenticate/verifyOtp`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ phoneNumber, otp }),
    });

    if (!response.ok) {
      throw new Error('Login failed');
    }

    const data = await response.json();
    
    // Set tokens in cookies if they exist in the response
    if (data.accessToken) {
      Cookies.set('accessToken', data.accessToken, { expires: 7 });
    }
    if (data.refreshToken) {
      Cookies.set('refreshToken', data.refreshToken, { expires: 14 });
    }
    
    return data;
  },

  logout: () => {
    Cookies.remove('accessToken');
    Cookies.remove('refreshToken');
  },

  isAuthenticated: () => {
    return Cookies.get('accessToken') !== undefined;
  },

      // Create a new user
      async addNewUser(user) {
        try {
          const response = await fetch(`${API_URL}/customer/addNewCustomer`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(user),
          });
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return await response.json();
        } catch (error) {
          console.error("Failed to create product:", error);
          throw error;
        }
      },

      getAccessTokenData() {
        const accessToken = Cookies.get("accessToken");
        if (!accessToken) {
          // Instead of throwing an error, return null
          return null;
        }
      
        try {
          const decodedToken = jwtDecode(accessToken);
          const { id, userName } = decodedToken;
      
          return { id, userName };
        } catch (error) {
          console.error("Error decoding access token:", error);
          return null; // Return null instead of throwing an error
        }
      },

       loginWithGoogle : async (token) => {
        try {
          const response = await fetch(`${API_URL}/authenticate/googleLogin`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json", // Ensure the Content-Type header is set
            },
            body: JSON.stringify({ token }), // Send the Google token in the request body
          });
      
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Login failed");
          }
      
          const data = await response.json();
          
          // Set tokens in cookies if they exist in the response
          if (data.accessToken) {
            Cookies.set('accessToken', data.accessToken, { expires: 7 });
          }
          if (data.refreshToken) {
            Cookies.set('refreshToken', data.refreshToken, { expires: 14 });
          }
          
          return data;

        } catch (error) {
          console.error("Error during Google Login:", error);
          throw error;
        }
      }   
    

};

export default authService; // Correct default export
